import AdditionalScheduleInput from './components/AdditionalScheduleInput';
import AddButton from './components/AddButton';
import ScheduleInput from './components/ScheduleInput';
import { IEditTeaserTotalSchedule } from 'modules/Teasers/EditTeaser/editTeaserState/editTeaserContext';
import React, { useMemo } from 'react';
import style from './ScheduleField.module.scss';

interface IScheduleField {
	totalSchedules: IEditTeaserTotalSchedule[];
	changeSchedule: (value: string) => void;
	changeAdditionalSchedule: (fieldId: string, value: string) => void;
	setSchedules: (value: IEditTeaserTotalSchedule[]) => void;
}

const ScheduleField: React.FC<IScheduleField> = ({
	totalSchedules,
	changeSchedule,
	changeAdditionalSchedule,
	setSchedules,
}) => {
	const additionalSchedulesList = useMemo(() => {
		return totalSchedules.map((el) => (
			<AdditionalScheduleInput
				key={el.id}
				fieldId={el.id}
				totalSchedules={totalSchedules}
				changeAdditionalSchedule={changeAdditionalSchedule}
				setSchedules={setSchedules}
			/>
		));
	}, [totalSchedules, changeAdditionalSchedule, setSchedules]);

	return (
		<div className={style.container}>
			<div className={style.mainField}>
				<ScheduleInput changeSchedule={changeSchedule} />
				<AddButton totalSchedules={totalSchedules} setSchedules={setSchedules} />
			</div>
			<div className={style.additionalFields}>{additionalSchedulesList}</div>
		</div>
	);
};

export default React.memo(ScheduleField);
